// src/config/colors.js
// Centralized color configuration for all brands

export const PHARMACY_HALO_COLORS = {
  YELLOW: '#FFAF3C',
  BLUE: '#002169',
  RED: '#6F1006',
  LIGHT_GRAY: '#f8f9fa',
  BORDER_GRAY: '#e5e7eb',
}

export const DOCLINK_COLORS = {
  LIGHT_PURPLE: '#d4ccdb',
  MID_PURPLE: '#8d679f',
  DARK_PURPLE: '#401d5e',
  ORANGE: '#E35437',
  ORANGE_LIGHT: '#EC8D79',
  LAVENDER_TINT: '#F3E8FF',
  PEACH_TINT: '#F5C6B3',
}

export const QUDA_COLORS = {
  TEAL_LIGHT: '#c9e9ea',
  TEAL_MID: '#39c0c0',
  TEAL_DARK: '#00827b',
  BURGUNDY: '#8c0f57',
  PURPLE_DARK: '#8C0F57', // New requested color
  GREY: '#56565b',
}

// Common colors that can be used across brands
export const COMMON_COLORS = {
  WHITE: '#FFFFFF',
  BLACK: '#000000',
  TRANSPARENT: 'transparent',
  LIGHT_GRAY: '#F4F4F4',
}

// Default brand colors (can be changed based on context)
export const DEFAULT_BRAND = PHARMACY_HALO_COLORS

// Export all colors as a single object for easy access
export const ALL_COLORS = {
  ...PHARMACY_HALO_COLORS,
  ...DOCLINK_COLORS,
  ...QUDA_COLORS,
  ...COMMON_COLORS,
}

// Usage examples:
// import { PHARMACY_HALO_COLORS, DOCLINK_COLORS } from '../config/colors'
// 
// backgroundColor: PHARMACY_HALO_COLORS.BLUE
// color: DOCLINK_COLORS.LIGHT_PURPLE
